import axios from "axios";

export const localPreviewPorts = new Set(["4173", "4174", "5173"]);
const currentPort = typeof window !== "undefined" ? window.location.port : "";
export const apiBaseUrl = import.meta.env.VITE_API_URL || (localPreviewPorts.has(currentPort) ? "http://localhost:4000/api/v1" : "/api/v1");
export const http = axios.create({ baseURL: apiBaseUrl, timeout: 15000, withCredentials: true });
http.interceptors.request.use(cfg => {
  cfg.headers["x-request-id"] = Math.random().toString(36).slice(2, 14);
  return cfg;
});
http.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) { localStorage.removeItem("cc_user"); localStorage.removeItem("cc_token"); localStorage.removeItem("cc_refresh_token"); if (typeof window !== "undefined") window.location.href = "/login"; }
  return Promise.reject(err);
});


export const getErr = (e: any) => {
  const raw = e?.response?.data?.error?.message || e?.message || "Something went wrong";
  return raw === "Network Error" ? "Unable to reach the server. Check that the backend is running and try again." : raw;
};
